import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    files: [],
}

const filesSlice = createSlice({
    name: 'files',
    initialState: initialState,
    reducers: {
        saveFilesData: (state, action) => {
            state.files = action.payload;
        }
    }
})

export default filesSlice.reducer;
export const {saveFilesData} = filesSlice.actions;